import React from 'react';
import styled from 'styled-components';

const backgroundsMap = {
    new: { text: 'New', color: '#82C3FF' },
    user: { text: 'User', color: '#75C422' },
    update: { text: 'Update', color: '#FFA500' },
};

const Chip = styled.div`
    display: inline-flex;
    height: 20px;
    padding: 0 12px;
    align-items: center;
    gap: 10px;
    border-radius: 20px;
    background-color: ${props => props.$bgColor};
    justify-content: center;
    font-size: 12px;
    white-space: nowrap;
    margin-right: 4px;
`;

/**
 * derives label types from port properties
 * @param {object} port - port object
 * @returns {string[]} array of label types
 */
export const getPortLabelTypes = (port) => {
    if (!port || !port._id) return [];
    return [
        port._id && !port.portApproved && 'new',
        port._id && !port.portApproved && 'user',
        port.changes && port.portApproved && 'update',
        port.history && port.history.length && port.portApproved && 'update',
    ].filter(Boolean);
};

/**
 * @param {string | string[]} types - 'new' | 'user' | 'update' or array of these
 * @returns {React.ReactElement[]} array of styled Chip components
 */
export const getLabels = (types) => {
    const typeArray = Array.isArray(types) ? types : [types];

    return typeArray
        .map((type, index) => {
            const config = backgroundsMap[type];
            if (!config) return null;

            return (
                <Chip key={`${type}-${index}`} $bgColor={config.color}>
                    {config.text}
                </Chip>
            );
        })
        .filter(Boolean);
};

export default getLabels;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/common/Labels.jsx